import React, { useState, useEffect } from 'react';
import {
  Tree,
  // message,
  Checkbox
} from 'antd';
import { DownOutlined } from '@ant-design/icons';
const { TreeNode } = Tree;
const HierarchyModal = (props) => {
  const [treeData, setTreeData] = useState(props.treeData || []);
  const [checkedArray, setCheckedArray] = useState(props.checkedArray || []);
  useEffect(() => {
    if (
      checkedArray !== props.checkedArray ||
      treeData !== props.treeData
    ) {
      setCheckedArray(props.checkedArray);
      setTreeData(props.treeData);
    }
  }, [props.checkedArray, props.treeData]);
  
const getTextOnChange = (itemData) => {
  let { Code, DisplayCode, key } = itemData;
  let { checkedArray, handleDropdownChange } = props;

  const itemExists = checkedArray && Array.isArray(checkedArray) && checkedArray[0] === Code;
  let updatedArray = itemExists ? [] : [Code];

  handleDropdownChange(updatedArray, DisplayCode, key);
};

  const renderTreeNodes = (data) => {
    const { checkedArray, selectedOption } = props;

    return data.map((item) => {
      const hasChildren = item.children && item.children.length > 0;
      const isMatchingType =
        (item.Type === 'Asset' && selectedOption === 'Asset') ||
        (item.Type === 'Device' && selectedOption === 'Device');

      const renderTitle = () => {
        const displayCode = item.DisplayCode ? setTranslation(item.DisplayCode) : '';
        const displayName = item.Name ? `(${setTranslation(item.Name)})` : '';

        if (isMatchingType) {
          return (
            <div className="item-row">
              <Checkbox
                key={item.Id}
                onClick={() => getTextOnChange(item)}
                checked={checkedArray && checkedArray[0] === item.Code}
                value={item.Code}
              />
            <span onClick={() => getTextOnChange(item)}>
                {`${displayCode} ${displayName}`}
              </span>
            </div>
          );
        }

        return <span>{`${displayCode} ${displayName}`}</span>;
      };

      if (hasChildren && item.Type === 'Device' && selectedOption === 'Device') {
        return (
          <TreeNode title={renderTitle()} key={item.Id} dataRef={item}>
            {renderTreeNodes(item.children)}
          </TreeNode>
        );
      }

      return (
        <TreeNode key={item.Id} title={renderTitle()} dataRef={item}>
          {hasChildren && renderTreeNodes(item.children)}
        </TreeNode>
      );
    });
  };

  const setTranslation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  return (
    <div
      style={{
        borderRight: '1px dashed white',
        width: '100%',
        flex: '35%',
        overflowY: 'auto',
        height: window.innerHeight - 250
      }}
    >
      <Tree
        className="hierarchyTree"
        showLine
        checkedKeys={checkedArray}
        defaultExpandAll={true}
        switcherIcon={<DownOutlined />}
      >
        {renderTreeNodes(treeData)}
      </Tree>
    </div>
  );
};

export default HierarchyModal;

